import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-65">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-66"></div>

      {/* Modal Content */}
      <div className="relative w-full max-w-3xl max-h-[85vh] bg-dark-900 border border-cyan-500/30 rounded-xl shadow-[0_0_30px_rgba(0,240,255,0.1)] flex flex-col animate-in fade-in zoom-in-95 duration-200" data-id="element-67">
        <div className="flex items-center justify-between p-6 border-b border-cyan-500/20" data-id="element-68">
          <h2 className="text-2xl font-bold text-white" data-id="element-69">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-cyan-400 transition-colors p-1 rounded-md hover:bg-cyan-500/10" aria-label="Close modal" data-id="element-70">
            <XIcon className="w-6 h-6" data-id="element-71" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto text-gray-300 space-y-6 custom-scrollbar" data-id="element-72">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="py-8 border-t border-cyan-900/30 bg-dark-950 relative z-10" data-id="element-73">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-74">
        <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-75">
          © {new Date().getFullYear()} The $10K AI Content Engine. All rights
          reserved.
        </p>
        <div className="flex items-center justify-center gap-6 text-sm" data-id="element-76">
          <button onClick={() => setIsPrivacyOpen(true)} className="text-gray-500 hover:text-cyan-400 transition-colors" data-id="element-77">
            Privacy Policy
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="text-gray-500 hover:text-cyan-400 transition-colors" data-id="element-78">
            Terms of Service
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Privacy Policy" data-id="element-79">
        <div className="space-y-4" data-id="element-80">
          <p data-id="element-81">Last updated: {new Date().toLocaleDateString()}</p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-82">
            1. Information We Collect
          </h3>
          <p data-id="element-83">
            We collect information you provide directly to us when you make a
            purchase, sign up for our newsletter, or communicate with us. This
            may include your name, email address, payment information, and any
            other details you choose to provide.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-84">
            2. How We Use Your Information
          </h3>
          <p data-id="element-85">
            We use the information we collect to process your transactions, send
            you technical notices and support messages, communicate with you
            about products, services, offers, and provide and maintain our
            services.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-86">
            3. Information Sharing
          </h3>
          <p data-id="element-87">
            We do not share your personal information with third parties except
            as necessary to provide our services (e.g., payment processors) or
            to comply with the law. We never sell your personal data to
            advertisers.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-88">4. Security</h3>
          <p data-id="element-89">
            We take reasonable measures to help protect information about you
            from loss, theft, misuse and unauthorized access, disclosure,
            alteration and destruction. However, no internet transmission is
            completely secure.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-90">5. Your Rights</h3>
          <p data-id="element-91">
            Depending on your location, you may have the right to access,
            correct, or delete your personal information. If you wish to
            exercise these rights, please contact our support team.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms of Service" data-id="element-92">
        <div className="space-y-4" data-id="element-93">
          <p data-id="element-94">Last updated: {new Date().toLocaleDateString()}</p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-95">
            1. Acceptance of Terms
          </h3>
          <p data-id="element-96">
            By accessing and using The $10K AI Content Engine, you accept and
            agree to be bound by the terms and provision of this agreement. If
            you do not agree to abide by these terms, please do not use this
            service.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-97">
            2. Intellectual Property
          </h3>
          <p data-id="element-98">
            All content included on this site, such as text, graphics, logos,
            images, as well as the compilation thereof, and any software used on
            the site, is the property of The $10K AI Content Engine or its
            suppliers and protected by copyright and other laws.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-99">3. Use License</h3>
          <p data-id="element-100">
            Permission is granted to temporarily download one copy of the
            materials (information or software) on The $10K AI Content Engine's
            website for personal, non-commercial transitory viewing only. This
            is the grant of a license, not a transfer of title.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-101">4. Disclaimer</h3>
          <p data-id="element-102">
            The materials on The $10K AI Content Engine's website are provided
            on an 'as is' basis. We make no warranties, expressed or implied,
            and hereby disclaim and negate all other warranties including,
            without limitation, implied warranties or conditions of
            merchantability, fitness for a particular purpose, or
            non-infringement of intellectual property or other violation of
            rights.
          </p>

          <h3 className="text-xl font-bold text-white mt-6" data-id="element-103">5. Limitations</h3>
          <p data-id="element-104">
            In no event shall The $10K AI Content Engine or its suppliers be
            liable for any damages (including, without limitation, damages for
            loss of data or profit, or due to business interruption) arising out
            of the use or inability to use the materials on our website.
          </p>
        </div>
      </Modal>
    </footer>;
}